import { requestApi } from "../../utils/requests";

export function trackPrometheusEvent(name, actionName) {
  const params = new URLSearchParams({ name, actionName });

  requestApi({ method: "GET", route: `/telemetry?${params}` });
}
